import columnTypes from '../columnTypes.js';
import types from '../types.js';

const ActiveDirectoryTables = [
  {
    key: 'ad-granular-details',
    name: 'AD Granular Details',
    [columnTypes.default.key]: [
      {
        source: 'SamAccountName',
        rename: 'Group Name',
        type: types.text,
      },
      {
        source: 'ShortName',
        rename: 'Domain',
        type: types.text,
      },
      {
        source: 'OwnerName',
        rename: 'Owner',
        type: types.text,
      },
      {
        source: 'ManagedBy',
        rename: 'Managed By',
        type: types.text,
      },
      {
        source: 'TotalChildren',
        rename: 'Children',
        type: types.number,
      },
      {
        source: 'TotalUsers',
        rename: 'Users',
        type: types.number,
      },
      {
        source: 'UniqueUsers',
        rename: 'Unique Users',
        type: types.number,
      },
      {
        source: 'NumSubGroups',
        rename: 'SubGroups',
        type: types.number,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Division',
        type: types.text,
      },
      {
        source: 'GroupScope',
        rename: 'Scope',
        type: types.text,
      },
      {
        source: 'GroupType',
        rename: 'Type',
        type: types.text,
      },
      {
        source: 'CreateDate',
        rename: 'Created',
        type: types.date,
      },
      {
        source: 'ModifyDate',
        rename: 'Modified',
        type: types.date,
      },
      {
        source: 'SVA',
        rename: 'Group Status',
        type: types.text,
      },
      {
        source: 'CircularReference',
        rename: 'Circular',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'AdminUsers',
        rename: 'Admin Users',
        type: types.number,
      },
      {
        source: 'DepartmentName',
        rename: 'Department',
        type: types.text,
      },
      {
        source: 'GroupDepth',
        rename: 'Depth',
        type: types.number,
      },
      {
        source: 'Description',
        rename: 'Description',
        type: types.text,
      },
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'IsAdmin',
        rename: 'Is Admin',
        type: types.text,
      },
      {
        source: 'IsEmpty',
        rename: 'Is Empty',
        type: types.text,
      },
      {
        source: 'RegularUsers',
        rename: 'Regular Users',
        type: types.number,
      },
      {
        source: 'SystemAccounts',
        rename: 'System Accounts',
        type: types.number,
      },
    ],
    [columnTypes.hidden.key]: [
      { source: 'BUID', rename: 'BUID' },
      { source: 'CMID', rename: 'CMID' },
      { source: 'UniqueID', rename: 'UniqueID' },
      { source: 'STSGuid', rename: 'STSGuid' },
      { source: 'domainID', rename: 'domainID' },
      { source: 'OwnerID', rename: 'OwnerID' },
    ],
  },
];

export default [...ActiveDirectoryTables];
